import Vue from 'vue'

import BorderdTable from '@/components/ui/BorderdTable'
import ToggleSwitch from '@/components/ui/ToggleSwitch'
import CaptionContents from '@/components/ui/CaptionContents'
import ButtonCard from '@/components/ui/ButtonCard'
import PopupConfirmation from '@/components/ui/PopupConfirmation'
import PopupTimeRangeSelector from '@/components/ui/PopupTimeRangeSelector'
import PopupDateRangeSelector from '@/components/ui/PopupDateRangeSelector'
import DatePicker from '@/components/ui/DatePicker'
import MonthPicker from '@/components/ui/MonthPicker'
import TimeSelector from '@/components/ui/TimeSelector'
import AutoLinkText from '@/components/ui/AutoLinkText'
import DragAndDropFileInput from '@/components/ui/DragAndDropFileInput'
import MultipleFileInput from '@/components/ui/MultipleFileInput'
import TextField from '@/components/ui/TextField'
import TextFieldHorizen from '@/components/ui/TextFieldHorizen'
import IconWithTooltip from '@/components/ui/IconWithTooltip'
import DonutChart from '@/components/ui/DonutChart'
import LineChart from '@/components/ui/LineChart'


Vue.component(BorderdTable.name, BorderdTable);
Vue.component(ToggleSwitch.name, ToggleSwitch);
Vue.component(TextField.name, TextField);
Vue.component(TextFieldHorizen.name, TextFieldHorizen);
Vue.component(CaptionContents.name, CaptionContents);
Vue.component(ButtonCard.name, ButtonCard);
Vue.component(PopupConfirmation.name, PopupConfirmation);
Vue.component(PopupTimeRangeSelector.name, PopupTimeRangeSelector);
Vue.component(PopupDateRangeSelector.name, PopupDateRangeSelector);
Vue.component(DatePicker.name, DatePicker);
Vue.component(MonthPicker.name, MonthPicker);
Vue.component(TimeSelector.name, TimeSelector);
Vue.component(AutoLinkText.name, AutoLinkText);
Vue.component(DragAndDropFileInput.name, DragAndDropFileInput);
Vue.component(MultipleFileInput.name, MultipleFileInput);
Vue.component(IconWithTooltip.name, IconWithTooltip);
Vue.component(DonutChart.name, DonutChart);
Vue.component(LineChart.name, LineChart);
